import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../service/modules/modules.component';
import { ServerService } from '../../../service/server/server.service';

@Component({
  selector: 'app-sale-payment-detaile',
  templateUrl: './sale-payment-detaile.component.html',
  styleUrls: ['./sale-payment-detaile.component.scss']
})
export class SalePaymentDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public server: any;
  site: string = this.serverService.get_site();
  lang: any;
  type_task: number;
  form1_group: FormGroup;
  user_info: any;
  user_id: number;
  id: number;
  i: number;
  code: number;
  title: string;
  search_array: any = [];
  invoice: number;
  list_load_file: any = [];
  config: any | undefined;
  sale_payment_date3_main: string;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog
    , private matDialogRef: MatDialogRef<SalePaymentDetaileComponent>) {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.invoice = dialog_data.invoice;
      this.create_form1();
      this.id = dialog_data.id;
      this.title = dialog_data.title;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          price: dialog_data.search_array.price,
          comment: dialog_data.search_array.comment,
          date3: dialog_data.search_array.date3,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null),
      'comment': new FormControl(null),
      'payment': new FormControl(null),
      'date3': new FormControl(null),
      'date3_main': new FormControl(null),
    });
    if (this.type_task == 2 || this.type_task == 1) {
    }

  }

  check_access(type_task, excel) {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.get_data(); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  change_start_date() {
    this.sale_payment_date3_main = this.form1_group.value.date3;
  }

  delete_file(i: number, id: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1537, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_load_file.splice(i, 1);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1535, id: this.id }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'title': res['result'][0].sale_payment_title,
            'payment': res['result'][0].sale_payment_price,
            'date3': res['result'][0].sale_payment_date3,
            'comment': res['result'][0].sale_payment_comment,
            'sort': res['result'][0].sale_payment_sort,
            'status_id': res['result'][0].sale_payment_status,
            'status_title': res['result'][0].status_title,
          }
          );
          this.sale_payment_date3_main = res['result'][0].sale_payment_date3_main;
          this.load_file(1);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    var obj = {
      'address': 1532, "user_id": this.user_id
      , 'title': this.form1_group.value.title
      , 'payment': this.form1_group.value.payment
      , 'date3': this.form1_group.value.date3
      , 'comment': this.form1_group.value.comment
      , 'invoice': this.invoice
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  update() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    var obj = {
      'address': 1533, "user_id": this.user_id
      , 'title': this.form1_group.value.title
      , 'payment': this.form1_group.value.payment
      , 'date3': this.sale_payment_date3_main
      , 'date3_main': this.form1_group.value.date3_main
      , 'comment': this.form1_group.value.comment
      , 'id': this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0], i: this.i }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update

  load_file(type) {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (type == 2) {
      $(document).ready(function () {
        $(".dz-complete").remove();
      });
    }

    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1536, code: this.id }).subscribe(
      (res) => {
        this.list_load_file = [];
        for (var i = 0; i < res['num']; i++) {
          this.list_load_file.push(res['result'][i]);
        }//end for
      }
    )
  }//end load_file


  load_services(id) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 26) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
        }
      }
    )
  }


  reset_input(id) {
    if (id == 26) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
  }


  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 2000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}






